export default __webpack_public_path__ + "static/media/hard-reset.fc6eb10f.svg";